var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _g, _path414, _g2, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoAddress(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 401,
    height: 400,
    viewBox: "0 0 401 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.29 64.356H241.684C241.684 64.356 249.775 42.256 262.228 42.256C274.68 42.256 278.581 57.5104 278.581 57.5104C278.581 57.5104 286.983 49.2224 293.884 49.2224C300.786 49.2224 306.787 60.1744 306.787 60.1744C306.787 60.1744 316.539 54.2848 323.29 64.356Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M361.327 87.9439H323.19C323.19 87.9439 331.712 75.5975 338.426 75.5975C345.139 75.5975 347.123 83.8287 347.123 83.8287C347.123 83.8287 351.862 79.9871 356.251 80.6735C360.641 81.3599 361.327 87.9439 361.327 87.9439Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M283.982 133.87H245.846C245.846 133.87 254.367 121.524 261.081 121.524C267.795 121.524 269.778 129.755 269.778 129.755C269.778 129.755 274.517 125.914 278.906 126.6C283.297 127.286 283.982 133.87 283.982 133.87Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.956 143.361H39.6729C39.6729 143.361 49.8457 120.65 60.7281 119.23C71.6105 117.811 76.8144 136.106 76.8144 136.106C76.8144 136.106 83.8329 129.639 89.3529 129.639C94.8729 129.639 99.1313 138.156 99.1313 138.156C99.1313 138.156 110.171 132.32 113.956 143.361Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M147.881 76.6152H97.7012C97.7012 76.6152 106.32 60.1608 115.672 59.9216C125.023 59.6816 129.938 72.3744 129.938 72.3744C129.938 72.3744 144.484 60.7 147.881 76.6152Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M228.511 154.897H198.684V311.249H228.511V154.897Z",
    fill: "#DBDBDB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M209.112 159.975H203.313V165.945H209.112V159.975Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M216.53 159.975H210.731V165.945H216.53V159.975Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M209.112 170.111H203.313V176.081H209.112V170.111Z",
    fill: "#EBEBEB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M216.53 170.111H210.731V176.081H216.53V170.111Z",
    fill: "#EBEBEB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M209.112 180.247H203.313V186.217H209.112V180.247Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M216.53 180.247H210.731V186.217H216.53V180.247Z",
    fill: "#EBEBEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M209.112 190.382H203.313V196.353H209.112V190.382Z",
    fill: "#EBEBEB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M216.53 190.382H210.731V196.353H216.53V190.382Z",
    fill: "#EBEBEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M209.112 200.518H203.313V206.489H209.112V200.518Z",
    fill: "#EBEBEB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M216.53 200.518H210.731V206.489H216.53V200.518Z",
    fill: "#EBEBEB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M209.112 210.654H203.313V216.625H209.112V210.654Z",
    fill: "#EBEBEB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M216.53 210.654H210.731V216.625H216.53V210.654Z",
    fill: "#EBEBEB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M209.112 220.79H203.313V226.76H209.112V220.79Z",
    fill: "#EBEBEB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M216.53 220.79H210.731V226.76H216.53V220.79Z",
    fill: "#EBEBEB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M209.112 230.926H203.313V236.895H209.112V230.926Z",
    fill: "#EBEBEB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M216.53 230.926H210.731V236.895H216.53V230.926Z",
    fill: "#EBEBEB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M209.112 241.062H203.313V247.032H209.112V241.062Z",
    fill: "#EBEBEB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M216.53 241.062H210.731V247.032H216.53V241.062Z",
    fill: "#EBEBEB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M209.112 251.198H203.313V257.168H209.112V251.198Z",
    fill: "#EBEBEB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M216.53 251.198H210.731V257.168H216.53V251.198Z",
    fill: "#EBEBEB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M209.112 261.333H203.313V267.303H209.112V261.333Z",
    fill: "#EBEBEB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M216.53 261.333H210.731V267.303H216.53V261.333Z",
    fill: "#EBEBEB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M209.112 271.469H203.313V277.439H209.112V271.469Z",
    fill: "#EBEBEB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M216.53 271.469H210.731V277.439H216.53V271.469Z",
    fill: "#EBEBEB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M209.112 281.605H203.313V287.575H209.112V281.605Z",
    fill: "#EBEBEB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M216.53 281.605H210.731V287.575H216.53V281.605Z",
    fill: "#EBEBEB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M209.112 291.74H203.313V297.71H209.112V291.74Z",
    fill: "#EBEBEB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M218.082 297.711H223.881V291.74H218.082V297.711Z",
    fill: "#EBEBEB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M218.082 287.574H223.881V281.604H218.082V287.574Z",
    fill: "#EBEBEB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M218.082 277.439H223.881V271.468H218.082V277.439Z",
    fill: "#EBEBEB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M218.082 267.303H223.881V261.333H218.082V267.303Z",
    fill: "#EBEBEB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M218.082 257.167H223.881V251.197H218.082V257.167Z",
    fill: "#EBEBEB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M218.082 247.031H223.881V241.061H218.082V247.031Z",
    fill: "#EBEBEB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M218.082 236.896H223.881V230.926H218.082V236.896Z",
    fill: "#EBEBEB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M218.082 226.76H223.881V220.79H218.082V226.76Z",
    fill: "#EBEBEB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M218.082 216.624H223.881V210.654H218.082V216.624Z",
    fill: "#EBEBEB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M218.082 206.489H223.881V200.518H218.082V206.489Z",
    fill: "#EBEBEB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M218.082 196.353H223.881V190.383H218.082V196.353Z",
    fill: "#EBEBEB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M218.082 186.217H223.881V180.246H218.082V186.217Z",
    fill: "#EBEBEB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M218.082 176.081H223.881V170.111H218.082V176.081Z",
    fill: "#EBEBEB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M218.082 165.946H223.881V159.976H218.082V165.946Z",
    fill: "#EBEBEB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M216.53 291.74H210.731V297.71H216.53V291.74Z",
    fill: "#EBEBEB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M252.028 154.897H228.511V311.249H252.028V154.897Z",
    fill: "#A6A6A6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M244.816 297.711H249.604V291.74H244.816V297.711Z",
    fill: "#C7C7C7"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M238.691 297.711H243.479V291.74H238.691V297.711Z",
    fill: "#C7C7C7"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M244.816 287.574H249.604V281.604H244.816V287.574Z",
    fill: "#C7C7C7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M238.691 287.574H243.479V281.604H238.691V287.574Z",
    fill: "#C7C7C7"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M244.816 277.439H249.604V271.468H244.816V277.439Z",
    fill: "#C7C7C7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M238.691 277.439H243.479V271.468H238.691V277.439Z",
    fill: "#C7C7C7"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M244.816 267.303H249.604V261.333H244.816V267.303Z",
    fill: "#C7C7C7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M238.691 267.303H243.479V261.333H238.691V267.303Z",
    fill: "#C7C7C7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M244.816 257.167H249.604V251.197H244.816V257.167Z",
    fill: "#C7C7C7"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M238.691 257.167H243.479V251.197H238.691V257.167Z",
    fill: "#C7C7C7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M244.816 247.031H249.604V241.061H244.816V247.031Z",
    fill: "#C7C7C7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M238.691 247.031H243.479V241.061H238.691V247.031Z",
    fill: "#C7C7C7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M244.816 236.896H249.604V230.926H244.816V236.896Z",
    fill: "#C7C7C7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M238.691 236.896H243.479V230.926H238.691V236.896Z",
    fill: "#C7C7C7"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M244.816 226.76H249.604V220.79H244.816V226.76Z",
    fill: "#C7C7C7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M238.691 226.76H243.479V220.79H238.691V226.76Z",
    fill: "#C7C7C7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M244.816 216.624H249.604V210.654H244.816V216.624Z",
    fill: "#C7C7C7"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M238.691 216.624H243.479V210.654H238.691V216.624Z",
    fill: "#C7C7C7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M244.816 206.489H249.604V200.518H244.816V206.489Z",
    fill: "#C7C7C7"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M238.691 206.489H243.479V200.518H238.691V206.489Z",
    fill: "#C7C7C7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M244.816 196.353H249.604V190.383H244.816V196.353Z",
    fill: "#C7C7C7"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M238.691 196.353H243.479V190.383H238.691V196.353Z",
    fill: "#C7C7C7"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M244.816 186.217H249.604V180.246H244.816V186.217Z",
    fill: "#C7C7C7"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M238.691 186.217H243.479V180.246H238.691V186.217Z",
    fill: "#C7C7C7"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M244.816 176.081H249.604V170.111H244.816V176.081Z",
    fill: "#C7C7C7"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M238.691 176.081H243.479V170.111H238.691V176.081Z",
    fill: "#C7C7C7"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M244.816 165.946H249.604V159.976H244.816V165.946Z",
    fill: "#C7C7C7"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M237.406 159.975H232.618V165.945H237.406V159.975Z",
    fill: "#C7C7C7"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M237.406 170.111H232.618V176.081H237.406V170.111Z",
    fill: "#C7C7C7"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M237.406 180.247H232.618V186.217H237.406V180.247Z",
    fill: "#C7C7C7"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M237.406 190.382H232.618V196.353H237.406V190.382Z",
    fill: "#C7C7C7"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M237.406 200.518H232.618V206.489H237.406V200.518Z",
    fill: "#C7C7C7"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M237.406 210.654H232.618V216.625H237.406V210.654Z",
    fill: "#C7C7C7"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M237.406 220.79H232.618V226.76H237.406V220.79Z",
    fill: "#C7C7C7"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M237.406 230.926H232.618V236.895H237.406V230.926Z",
    fill: "#C7C7C7"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M237.406 241.062H232.618V247.032H237.406V241.062Z",
    fill: "#C7C7C7"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M237.406 251.198H232.618V257.168H237.406V251.198Z",
    fill: "#C7C7C7"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M237.406 261.333H232.618V267.303H237.406V261.333Z",
    fill: "#C7C7C7"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M237.406 271.469H232.618V277.439H237.406V271.469Z",
    fill: "#C7C7C7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M237.406 281.605H232.618V287.575H237.406V281.605Z",
    fill: "#C7C7C7"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M237.406 291.74H232.618V297.71H237.406V291.74Z",
    fill: "#C7C7C7"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M238.691 165.946H243.479V159.976H238.691V165.946Z",
    fill: "#C7C7C7"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M121.272 151.485H90.1572V311.249H121.272V151.485Z",
    fill: "#EBEBEB"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M121.273 148.304H89.4092V151.486H121.273V148.304Z",
    fill: "#C7C7C7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1235 156.174H92.9707V311.25H96.1235V156.174Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M101.707 156.174H98.5547V311.25H101.707V156.174Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M107.291 156.174H104.139V311.25H107.291V156.174Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M112.875 156.174H109.723V311.25H112.875V156.174Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M118.459 156.174H115.307V311.25H118.459V156.174Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1235 160.193H92.9707V166.473H96.1235V160.193Z",
    fill: "#EBEBEB"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M101.707 160.193H98.5547V166.473H101.707V160.193Z",
    fill: "#EBEBEB"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M107.291 160.193H104.139V166.473H107.291V160.193Z",
    fill: "#EBEBEB"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M112.875 160.193H109.723V166.473H112.875V160.193Z",
    fill: "#EBEBEB"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M118.459 160.193H115.307V166.473H118.459V160.193Z",
    fill: "#EBEBEB"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1235 170.401H92.9707V176.681H96.1235V170.401Z",
    fill: "#EBEBEB"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M101.707 170.401H98.5547V176.681H101.707V170.401Z",
    fill: "#EBEBEB"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M107.291 170.401H104.139V176.681H107.291V170.401Z",
    fill: "#EBEBEB"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M112.875 170.401H109.723V176.681H112.875V170.401Z",
    fill: "#EBEBEB"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M118.459 170.401H115.307V176.681H118.459V170.401Z",
    fill: "#EBEBEB"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1235 180.607H92.9707V186.887H96.1235V180.607Z",
    fill: "#EBEBEB"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M101.707 180.607H98.5547V186.887H101.707V180.607Z",
    fill: "#EBEBEB"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M107.291 180.607H104.139V186.887H107.291V180.607Z",
    fill: "#EBEBEB"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M112.875 180.607H109.723V186.887H112.875V180.607Z",
    fill: "#EBEBEB"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M118.459 180.607H115.307V186.887H118.459V180.607Z",
    fill: "#EBEBEB"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1235 190.813H92.9707V197.093H96.1235V190.813Z",
    fill: "#EBEBEB"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M101.707 190.813H98.5547V197.093H101.707V190.813Z",
    fill: "#EBEBEB"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M107.291 190.813H104.139V197.093H107.291V190.813Z",
    fill: "#EBEBEB"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M112.875 190.813H109.723V197.093H112.875V190.813Z",
    fill: "#EBEBEB"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M118.459 190.813H115.307V197.093H118.459V190.813Z",
    fill: "#EBEBEB"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1235 201.021H92.9707V207.301H96.1235V201.021Z",
    fill: "#EBEBEB"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M101.707 201.021H98.5547V207.301H101.707V201.021Z",
    fill: "#EBEBEB"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M107.291 201.021H104.139V207.301H107.291V201.021Z",
    fill: "#EBEBEB"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M112.875 201.021H109.723V207.301H112.875V201.021Z",
    fill: "#EBEBEB"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M118.459 201.021H115.307V207.301H118.459V201.021Z",
    fill: "#EBEBEB"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1235 211.227H92.9707V217.507H96.1235V211.227Z",
    fill: "#EBEBEB"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M101.707 211.227H98.5547V217.507H101.707V211.227Z",
    fill: "#EBEBEB"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M107.291 211.227H104.139V217.507H107.291V211.227Z",
    fill: "#EBEBEB"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M112.875 211.227H109.723V217.507H112.875V211.227Z",
    fill: "#EBEBEB"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M118.459 211.227H115.307V217.507H118.459V211.227Z",
    fill: "#EBEBEB"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1235 221.433H92.9707V227.713H96.1235V221.433Z",
    fill: "#EBEBEB"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M101.707 221.433H98.5547V227.713H101.707V221.433Z",
    fill: "#EBEBEB"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M107.291 221.433H104.139V227.713H107.291V221.433Z",
    fill: "#EBEBEB"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M112.875 221.433H109.723V227.713H112.875V221.433Z",
    fill: "#EBEBEB"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M118.459 221.433H115.307V227.713H118.459V221.433Z",
    fill: "#EBEBEB"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1235 231.641H92.9707V237.921H96.1235V231.641Z",
    fill: "#EBEBEB"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M101.707 231.641H98.5547V237.921H101.707V231.641Z",
    fill: "#EBEBEB"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M107.291 231.641H104.139V237.921H107.291V231.641Z",
    fill: "#EBEBEB"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M112.875 231.641H109.723V237.921H112.875V231.641Z",
    fill: "#EBEBEB"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M118.459 231.641H115.307V237.921H118.459V231.641Z",
    fill: "#EBEBEB"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1235 241.847H92.9707V248.127H96.1235V241.847Z",
    fill: "#EBEBEB"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M101.707 241.847H98.5547V248.127H101.707V241.847Z",
    fill: "#EBEBEB"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M107.291 241.847H104.139V248.127H107.291V241.847Z",
    fill: "#EBEBEB"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M112.875 241.847H109.723V248.127H112.875V241.847Z",
    fill: "#EBEBEB"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M118.459 241.847H115.307V248.127H118.459V241.847Z",
    fill: "#EBEBEB"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1235 252.053H92.9707V258.333H96.1235V252.053Z",
    fill: "#EBEBEB"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M101.707 252.053H98.5547V258.333H101.707V252.053Z",
    fill: "#EBEBEB"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M107.291 252.053H104.139V258.333H107.291V252.053Z",
    fill: "#EBEBEB"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M112.875 252.053H109.723V258.333H112.875V252.053Z",
    fill: "#EBEBEB"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M118.459 252.053H115.307V258.333H118.459V252.053Z",
    fill: "#EBEBEB"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1235 262.261H92.9707V268.541H96.1235V262.261Z",
    fill: "#EBEBEB"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M101.707 262.261H98.5547V268.541H101.707V262.261Z",
    fill: "#EBEBEB"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M107.291 262.261H104.139V268.541H107.291V262.261Z",
    fill: "#EBEBEB"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M112.875 262.261H109.723V268.541H112.875V262.261Z",
    fill: "#EBEBEB"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M118.459 262.261H115.307V268.541H118.459V262.261Z",
    fill: "#EBEBEB"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1235 272.467H92.9707V278.747H96.1235V272.467Z",
    fill: "#EBEBEB"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M101.707 272.467H98.5547V278.747H101.707V272.467Z",
    fill: "#EBEBEB"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M107.291 272.467H104.139V278.747H107.291V272.467Z",
    fill: "#EBEBEB"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M112.875 272.467H109.723V278.747H112.875V272.467Z",
    fill: "#EBEBEB"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M118.459 272.467H115.307V278.747H118.459V272.467Z",
    fill: "#EBEBEB"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1235 282.674H92.9707V288.954H96.1235V282.674Z",
    fill: "#EBEBEB"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M101.707 282.674H98.5547V288.954H101.707V282.674Z",
    fill: "#EBEBEB"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M107.291 282.674H104.139V288.954H107.291V282.674Z",
    fill: "#EBEBEB"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M112.875 282.674H109.723V288.954H112.875V282.674Z",
    fill: "#EBEBEB"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M118.459 282.674H115.307V288.954H118.459V282.674Z",
    fill: "#EBEBEB"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1235 292.88H92.9707V311.249H96.1235V292.88Z",
    fill: "#EBEBEB"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M101.707 292.88H98.5547V311.249H101.707V292.88Z",
    fill: "#EBEBEB"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M107.291 292.88H104.139V311.249H107.291V292.88Z",
    fill: "#EBEBEB"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M112.875 292.88H109.723V311.249H112.875V292.88Z",
    fill: "#EBEBEB"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M118.459 292.88H115.307V311.249H118.459V292.88Z",
    fill: "#EBEBEB"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M141.249 151.485H121.273V311.249H141.249V151.485Z",
    fill: "#DBDBDB"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M142.114 148.304H121.273V151.486H142.114V148.304Z",
    fill: "#C7C7C7"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M127.239 156.174H124.086V311.25H127.239V156.174Z",
    fill: "#C7C7C7"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M132.823 156.174H129.67V311.25H132.823V156.174Z",
    fill: "#C7C7C7"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M138.408 156.174H135.255V311.25H138.408V156.174Z",
    fill: "#C7C7C7"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M127.239 160.193H124.086V166.473H127.239V160.193Z",
    fill: "#DBDBDB"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M132.823 160.193H129.67V166.473H132.823V160.193Z",
    fill: "#DBDBDB"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M138.408 160.193H135.255V166.473H138.408V160.193Z",
    fill: "#DBDBDB"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M127.239 170.401H124.086V176.681H127.239V170.401Z",
    fill: "#DBDBDB"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M132.823 170.401H129.67V176.681H132.823V170.401Z",
    fill: "#DBDBDB"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M138.408 170.401H135.255V176.681H138.408V170.401Z",
    fill: "#DBDBDB"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M127.239 180.607H124.086V186.887H127.239V180.607Z",
    fill: "#DBDBDB"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M132.823 180.607H129.67V186.887H132.823V180.607Z",
    fill: "#DBDBDB"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M138.408 180.607H135.255V186.887H138.408V180.607Z",
    fill: "#DBDBDB"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M127.239 190.813H124.086V197.093H127.239V190.813Z",
    fill: "#DBDBDB"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M132.823 190.813H129.67V197.093H132.823V190.813Z",
    fill: "#DBDBDB"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M138.408 190.813H135.255V197.093H138.408V190.813Z",
    fill: "#DBDBDB"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M127.239 201.021H124.086V207.301H127.239V201.021Z",
    fill: "#DBDBDB"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M132.823 201.021H129.67V207.301H132.823V201.021Z",
    fill: "#DBDBDB"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M138.408 201.021H135.255V207.301H138.408V201.021Z",
    fill: "#DBDBDB"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M127.239 211.227H124.086V217.507H127.239V211.227Z",
    fill: "#DBDBDB"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M132.823 211.227H129.67V217.507H132.823V211.227Z",
    fill: "#DBDBDB"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M138.408 211.227H135.255V217.507H138.408V211.227Z",
    fill: "#DBDBDB"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M127.239 221.433H124.086V227.713H127.239V221.433Z",
    fill: "#DBDBDB"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M132.823 221.433H129.67V227.713H132.823V221.433Z",
    fill: "#DBDBDB"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M138.408 221.433H135.255V227.713H138.408V221.433Z",
    fill: "#DBDBDB"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M127.239 231.641H124.086V237.921H127.239V231.641Z",
    fill: "#DBDBDB"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M132.823 231.641H129.67V237.921H132.823V231.641Z",
    fill: "#DBDBDB"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M138.408 231.641H135.255V237.921H138.408V231.641Z",
    fill: "#DBDBDB"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M127.239 241.847H124.086V248.127H127.239V241.847Z",
    fill: "#DBDBDB"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M132.823 241.847H129.67V248.127H132.823V241.847Z",
    fill: "#DBDBDB"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M138.408 241.847H135.255V248.127H138.408V241.847Z",
    fill: "#DBDBDB"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M127.239 252.053H124.086V258.333H127.239V252.053Z",
    fill: "#DBDBDB"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M132.823 252.053H129.67V258.333H132.823V252.053Z",
    fill: "#DBDBDB"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M138.408 252.053H135.255V258.333H138.408V252.053Z",
    fill: "#DBDBDB"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M127.239 262.261H124.086V268.541H127.239V262.261Z",
    fill: "#DBDBDB"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M132.823 262.261H129.67V268.541H132.823V262.261Z",
    fill: "#DBDBDB"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M138.408 262.261H135.255V268.541H138.408V262.261Z",
    fill: "#DBDBDB"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M127.239 272.467H124.086V278.747H127.239V272.467Z",
    fill: "#DBDBDB"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M132.823 272.467H129.67V278.747H132.823V272.467Z",
    fill: "#DBDBDB"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M138.408 272.467H135.255V278.747H138.408V272.467Z",
    fill: "#DBDBDB"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M127.239 282.674H124.086V288.954H127.239V282.674Z",
    fill: "#DBDBDB"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M132.823 282.674H129.67V288.954H132.823V282.674Z",
    fill: "#DBDBDB"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M138.408 282.674H135.255V288.954H138.408V282.674Z",
    fill: "#DBDBDB"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M127.239 292.88H124.086V311.249H127.239V292.88Z",
    fill: "#DBDBDB"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M132.823 292.88H129.67V311.249H132.823V292.88Z",
    fill: "#DBDBDB"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M138.408 292.88H135.255V311.249H138.408V292.88Z",
    fill: "#DBDBDB"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1219 199.334H46.6123V311.249H76.1219V199.334Z",
    fill: "#EBEBEB"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1216 191.912H50.8096V199.334H76.1216V191.912Z",
    fill: "#C7C7C7"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M72.887 203.209H49.8486V286.872H72.887V203.209Z",
    fill: "#DBDBDB"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M72.887 211.193H49.8486V213.17H72.887V211.193Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M72.887 219.382H49.8486V221.359H72.887V219.382Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M72.887 227.571H49.8486V229.548H72.887V227.571Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M72.887 235.76H49.8486V237.737H72.887V235.76Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M72.887 243.95H49.8486V245.926H72.887V243.95Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M72.887 252.138H49.8486V254.115H72.887V252.138Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M72.887 260.327H49.8486V262.304H72.887V260.327Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M72.887 268.517H49.8486V270.494H72.887V268.517Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M72.887 276.706H49.8486V278.682H72.887V276.706Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M72.887 284.895H49.8486V286.872H72.887V284.895Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6053 199.334H76.1221V311.249H94.6053V199.334Z",
    fill: "#DBDBDB"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8317 191.912H76.1221V199.334H91.8317V191.912Z",
    fill: "#A6A6A6"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8811 203.209H78.6699V286.872H92.8811V203.209Z",
    fill: "#C7C7C7"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8811 211.193H78.6699V213.17H92.8811V211.193Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8811 219.382H78.6699V221.359H92.8811V219.382Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8811 227.571H78.6699V229.548H92.8811V227.571Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8811 235.76H78.6699V237.737H92.8811V235.76Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8811 243.95H78.6699V245.926H92.8811V243.95Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8811 252.138H78.6699V254.115H92.8811V252.138Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8811 260.327H78.6699V262.304H92.8811V260.327Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8811 268.517H78.6699V270.494H92.8811V268.517Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8811 276.706H78.6699V278.682H92.8811V276.706Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8811 284.895H78.6699V286.872H92.8811V284.895Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M326.052 201.222H310.291V219.839H326.052V201.222Z",
    fill: "#DBDBDB"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M336.044 201.222H326.051V220.522H336.044V201.222Z",
    fill: "#C7C7C7"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M336.71 209.442H326.792V220.522H336.71V209.442Z",
    fill: "#DBDBDB"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M342.895 209.442H336.709V220.522H342.895V209.442Z",
    fill: "#C7C7C7"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M329.73 218.629H304.245V311.249H329.73V218.629Z",
    fill: "#EBEBEB"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M315.173 222.61H307.159V225.885H315.173V222.61Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M325.424 222.61H317.41V225.885H325.424V222.61Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M315.173 228.17H307.159V231.444H315.173V228.17Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M325.424 228.17H317.41V231.444H325.424V228.17Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M315.173 233.729H307.159V237.003H315.173V233.729Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M325.424 233.729H317.41V237.003H325.424V233.729Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M315.173 239.288H307.159V242.562H315.173V239.288Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M325.424 239.288H317.41V242.562H325.424V239.288Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M315.173 244.848H307.159V248.122H315.173V244.848Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M325.424 244.848H317.41V248.122H325.424V244.848Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M315.173 250.407H307.159V253.681H315.173V250.407Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M325.424 250.407H317.41V253.681H325.424V250.407Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M315.173 255.966H307.159V259.241H315.173V255.966Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M325.424 255.966H317.41V259.241H325.424V255.966Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M315.173 261.526H307.159V264.8H315.173V261.526Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M325.424 261.526H317.41V264.8H325.424V261.526Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M315.173 267.085H307.159V270.359H315.173V267.085Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M325.424 267.085H317.41V270.359H325.424V267.085Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M315.173 272.645H307.159V275.919H315.173V272.645Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M325.424 272.645H317.41V275.919H325.424V272.645Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M315.173 278.204H307.159V281.478H315.173V278.204Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M325.424 278.204H317.41V281.478H325.424V278.204Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M315.173 283.763H307.159V287.038H315.173V283.763Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M325.424 283.763H317.41V287.038H325.424V283.763Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M315.173 289.322H307.159V292.597H315.173V289.322Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M325.424 289.322H317.41V292.597H325.424V289.322Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M315.173 294.882H307.159V298.156H315.173V294.882Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M325.424 294.882H317.41V298.156H325.424V294.882Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M350.381 218.629H329.729V311.249H350.381V218.629Z",
    fill: "#C7C7C7"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M341.731 298.156H348.311V294.882H341.731V298.156Z",
    fill: "#EBEBEB"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M333.314 298.156H339.894V294.882H333.314V298.156Z",
    fill: "#EBEBEB"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M341.731 292.597H348.311V289.323H341.731V292.597Z",
    fill: "#EBEBEB"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M333.314 292.597H339.894V289.323H333.314V292.597Z",
    fill: "#EBEBEB"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M341.731 287.037H348.311V283.763H341.731V287.037Z",
    fill: "#EBEBEB"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M333.314 287.037H339.894V283.763H333.314V287.037Z",
    fill: "#EBEBEB"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M341.731 281.478H348.311V278.204H341.731V281.478Z",
    fill: "#EBEBEB"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M333.314 281.478H339.894V278.204H333.314V281.478Z",
    fill: "#EBEBEB"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M341.731 275.918H348.311V272.644H341.731V275.918Z",
    fill: "#EBEBEB"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M333.314 275.918H339.894V272.644H333.314V275.918Z",
    fill: "#EBEBEB"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M341.731 270.36H348.311V267.085H341.731V270.36Z",
    fill: "#EBEBEB"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M333.314 270.36H339.894V267.085H333.314V270.36Z",
    fill: "#EBEBEB"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M341.731 264.8H348.311V261.526H341.731V264.8Z",
    fill: "#EBEBEB"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M333.314 264.8H339.894V261.526H333.314V264.8Z",
    fill: "#EBEBEB"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M341.731 259.241H348.311V255.966H341.731V259.241Z",
    fill: "#EBEBEB"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M333.314 259.241H339.894V255.966H333.314V259.241Z",
    fill: "#EBEBEB"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M341.731 253.682H348.311V250.407H341.731V253.682Z",
    fill: "#EBEBEB"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M333.314 253.682H339.894V250.407H333.314V253.682Z",
    fill: "#EBEBEB"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M341.731 248.122H348.311V244.847H341.731V248.122Z",
    fill: "#EBEBEB"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M333.314 248.122H339.894V244.847H333.314V248.122Z",
    fill: "#EBEBEB"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M341.731 242.563H348.311V239.289H341.731V242.563Z",
    fill: "#EBEBEB"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M333.314 242.563H339.894V239.289H333.314V242.563Z",
    fill: "#EBEBEB"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M341.731 237.004H348.311V233.729H341.731V237.004Z",
    fill: "#EBEBEB"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M333.314 237.004H339.894V233.729H333.314V237.004Z",
    fill: "#EBEBEB"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M341.731 231.444H348.311V228.17H341.731V231.444Z",
    fill: "#EBEBEB"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M333.314 231.444H339.894V228.17H333.314V231.444Z",
    fill: "#EBEBEB"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M341.731 225.885H348.311V222.61H341.731V225.885Z",
    fill: "#EBEBEB"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M333.314 225.885H339.894V222.61H333.314V225.885Z",
    fill: "#EBEBEB"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M155.66 201.222H139.899V219.839H155.66V201.222Z",
    fill: "#DBDBDB"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M165.653 201.222H155.66V220.522H165.653V201.222Z",
    fill: "#C7C7C7"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M166.319 209.442H156.401V220.522H166.319V209.442Z",
    fill: "#DBDBDB"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M172.504 209.442H166.318V220.522H172.504V209.442Z",
    fill: "#C7C7C7"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M159.339 218.629H133.854V311.249H159.339V218.629Z",
    fill: "#EBEBEB"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M144.782 222.61H136.769V225.885H144.782V222.61Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M155.033 222.61H147.02V225.885H155.033V222.61Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M144.782 228.17H136.769V231.444H144.782V228.17Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M155.033 228.17H147.02V231.444H155.033V228.17Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M144.782 233.729H136.769V237.003H144.782V233.729Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M155.033 233.729H147.02V237.003H155.033V233.729Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M144.782 239.288H136.769V242.562H144.782V239.288Z",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M155.033 239.288H147.02V242.562H155.033V239.288Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M144.782 244.848H136.769V248.122H144.782V244.848Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M155.033 244.848H147.02V248.122H155.033V244.848Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M144.782 250.407H136.769V253.681H144.782V250.407Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M155.033 250.407H147.02V253.681H155.033V250.407Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M144.782 255.966H136.769V259.241H144.782V255.966Z",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M155.033 255.966H147.02V259.241H155.033V255.966Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M144.782 261.526H136.769V264.8H144.782V261.526Z",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M155.033 261.526H147.02V264.8H155.033V261.526Z",
    fill: "white"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M144.782 267.085H136.769V270.359H144.782V267.085Z",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M155.033 267.085H147.02V270.359H155.033V267.085Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M144.782 272.645H136.769V275.919H144.782V272.645Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M155.033 272.645H147.02V275.919H155.033V272.645Z",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M144.782 278.204H136.769V281.478H144.782V278.204Z",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M155.033 278.204H147.02V281.478H155.033V278.204Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M144.782 283.763H136.769V287.038H144.782V283.763Z",
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M155.033 283.763H147.02V287.038H155.033V283.763Z",
    fill: "white"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M144.782 289.322H136.769V292.597H144.782V289.322Z",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M155.033 289.322H147.02V292.597H155.033V289.322Z",
    fill: "white"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M144.782 294.882H136.769V298.156H144.782V294.882Z",
    fill: "white"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M155.033 294.882H147.02V298.156H155.033V294.882Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M179.99 218.629H159.339V311.249H179.99V218.629Z",
    fill: "#C7C7C7"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M171.338 298.156H177.918V294.882H171.338V298.156Z",
    fill: "#EBEBEB"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M162.922 298.156H169.502V294.882H162.922V298.156Z",
    fill: "#EBEBEB"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M171.338 292.597H177.918V289.323H171.338V292.597Z",
    fill: "#EBEBEB"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M162.922 292.597H169.502V289.323H162.922V292.597Z",
    fill: "#EBEBEB"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M171.338 287.037H177.918V283.763H171.338V287.037Z",
    fill: "#EBEBEB"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M162.922 287.037H169.502V283.763H162.922V287.037Z",
    fill: "#EBEBEB"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M171.338 281.478H177.918V278.204H171.338V281.478Z",
    fill: "#EBEBEB"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M162.922 281.478H169.502V278.204H162.922V281.478Z",
    fill: "#EBEBEB"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M171.338 275.918H177.918V272.644H171.338V275.918Z",
    fill: "#EBEBEB"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M162.922 275.918H169.502V272.644H162.922V275.918Z",
    fill: "#EBEBEB"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M171.338 270.36H177.918V267.085H171.338V270.36Z",
    fill: "#EBEBEB"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M162.922 270.36H169.502V267.085H162.922V270.36Z",
    fill: "#EBEBEB"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M171.338 264.8H177.918V261.526H171.338V264.8Z",
    fill: "#EBEBEB"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M162.922 264.8H169.502V261.526H162.922V264.8Z",
    fill: "#EBEBEB"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M171.338 259.241H177.918V255.966H171.338V259.241Z",
    fill: "#EBEBEB"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M162.922 259.241H169.502V255.966H162.922V259.241Z",
    fill: "#EBEBEB"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M171.338 253.682H177.918V250.407H171.338V253.682Z",
    fill: "#EBEBEB"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M162.922 253.682H169.502V250.407H162.922V253.682Z",
    fill: "#EBEBEB"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M171.338 248.122H177.918V244.847H171.338V248.122Z",
    fill: "#EBEBEB"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M162.922 248.122H169.502V244.847H162.922V248.122Z",
    fill: "#EBEBEB"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M171.338 242.563H177.918V239.289H171.338V242.563Z",
    fill: "#EBEBEB"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M162.922 242.563H169.502V239.289H162.922V242.563Z",
    fill: "#EBEBEB"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M171.338 237.004H177.918V233.729H171.338V237.004Z",
    fill: "#EBEBEB"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M162.922 237.004H169.502V233.729H162.922V237.004Z",
    fill: "#EBEBEB"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M171.338 231.444H177.918V228.17H171.338V231.444Z",
    fill: "#EBEBEB"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M162.922 231.444H169.502V228.17H162.922V231.444Z",
    fill: "#EBEBEB"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M171.338 225.885H177.918V222.61H171.338V225.885Z",
    fill: "#EBEBEB"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M162.922 225.885H169.502V222.61H162.922V225.885Z",
    fill: "#EBEBEB"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M200.5 365.413C276.571 365.413 338.238 359.251 338.238 351.65C338.238 344.048 276.571 337.886 200.5 337.886C124.43 337.886 62.7627 344.048 62.7627 351.65C62.7627 359.251 124.43 365.413 200.5 365.413Z",
    fill: "#EBEBEB"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M278.199 250.897H248.14V311.25H278.199V250.897Z",
    fill: "#37474F"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M258.186 256.121H252.867V259.818H258.186V256.121Z",
    fill: "#455A64"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M258.186 264.018H252.867V267.716H258.186V264.018Z",
    fill: "#455A64"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M258.186 271.916H252.867V275.614H258.186V271.916Z",
    fill: "#455A64"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M258.186 279.814H252.867V283.511H258.186V279.814Z",
    fill: "#455A64"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M258.186 287.711H252.867V291.409H258.186V287.711Z",
    fill: "#455A64"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M258.186 295.609H252.867V299.306H258.186V295.609Z",
    fill: "#455A64"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M258.186 303.507H252.867V307.205H258.186V303.507Z",
    fill: "#455A64"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M265.839 256.121H260.52V259.818H265.839V256.121Z",
    fill: "#455A64"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M265.839 264.018H260.52V267.716H265.839V264.018Z",
    fill: "#455A64"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M265.839 271.916H260.52V275.614H265.839V271.916Z",
    fill: "#455A64"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M265.839 279.814H260.52V283.511H265.839V279.814Z",
    fill: "#455A64"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M265.839 287.711H260.52V291.409H265.839V287.711Z",
    fill: "#455A64"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M265.839 295.609H260.52V299.306H265.839V295.609Z",
    fill: "#455A64"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M265.839 303.507H260.52V307.205H265.839V303.507Z",
    fill: "#455A64"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M273.472 256.121H268.152V259.818H273.472V256.121Z",
    fill: "#455A64"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M273.472 264.018H268.152V267.716H273.472V264.018Z",
    fill: "#455A64"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M273.472 271.916H268.152V275.614H273.472V271.916Z",
    fill: "#455A64"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M273.472 279.814H268.152V283.511H273.472V279.814Z",
    fill: "#455A64"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M273.472 287.711H268.152V291.409H273.472V287.711Z",
    fill: "#455A64"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M273.472 295.609H268.152V299.306H273.472V295.609Z",
    fill: "#455A64"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M273.472 303.507H268.152V307.205H273.472V303.507Z",
    fill: "#455A64"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M278.199 244.608H258.187V250.896H278.199V244.608Z",
    fill: "#455A64"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M278.199 240.715H265.512V244.608H278.199V240.715Z",
    fill: "#37474F"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M299.289 250.897H278.199V311.25H299.289V250.897Z",
    fill: "#263238"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M292.8 306.615H297.131V302.917H292.8V306.615Z",
    fill: "#37474F"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M292.8 298.717H297.131V295.02H292.8V298.717Z",
    fill: "#37474F"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M292.8 290.819H297.131V287.122H292.8V290.819Z",
    fill: "#37474F"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M292.8 282.921H297.131V279.224H292.8V282.921Z",
    fill: "#37474F"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M292.8 275.024H297.131V271.326H292.8V275.024Z",
    fill: "#37474F"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M292.8 267.126H297.131V263.428H292.8V267.126Z",
    fill: "#37474F"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M292.8 259.229H297.131V255.531H292.8V259.229Z",
    fill: "#37474F"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M286.572 306.615H290.902V302.917H286.572V306.615Z",
    fill: "#37474F"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M286.572 298.717H290.902V295.02H286.572V298.717Z",
    fill: "#37474F"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M286.572 290.819H290.902V287.122H286.572V290.819Z",
    fill: "#37474F"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M286.572 282.921H290.902V279.224H286.572V282.921Z",
    fill: "#37474F"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M286.572 275.024H290.902V271.326H286.572V275.024Z",
    fill: "#37474F"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M286.572 267.126H290.902V263.428H286.572V267.126Z",
    fill: "#37474F"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M286.572 259.229H290.902V255.531H286.572V259.229Z",
    fill: "#37474F"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M280.358 306.615H284.688V302.917H280.358V306.615Z",
    fill: "#37474F"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M280.358 298.717H284.688V295.02H280.358V298.717Z",
    fill: "#37474F"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M280.358 290.819H284.688V287.122H280.358V290.819Z",
    fill: "#37474F"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M280.358 282.921H284.688V279.224H280.358V282.921Z",
    fill: "#37474F"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M280.358 275.024H284.688V271.326H280.358V275.024Z",
    fill: "#37474F"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M280.358 267.126H284.688V263.428H280.358V267.126Z",
    fill: "#37474F"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M280.358 259.229H284.688V255.531H280.358V259.229Z",
    fill: "#37474F"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M296.094 244.608H278.199V250.896H296.094V244.608Z",
    fill: "#37474F"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M287.896 240.715H278.199V244.608H287.896V240.715Z",
    fill: "#263238"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M270.019 77.9712H278.13C260.345 77.9712 245.938 92.6008 245.938 110.652C245.938 128.712 260.346 143.341 278.13 143.341H270.019C252.234 143.341 237.827 128.712 237.827 110.652C237.827 92.6 252.234 77.9712 270.019 77.9712Z",
    fill: "#514EFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.019 77.9712H278.13C260.345 77.9712 245.938 92.6008 245.938 110.652C245.938 128.712 260.346 143.341 278.13 143.341H270.019C252.234 143.341 237.827 128.712 237.827 110.652C237.827 92.6 252.234 77.9712 270.019 77.9712Z",
    fill: "black"
  }))), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M278.128 236.09H270.02C302.697 198.014 333.31 156.283 328.808 110.2C325.884 80.3528 305.621 50.6272 270.02 50.6272H278.128C313.73 50.6272 333.992 80.3528 336.916 110.2C341.419 156.283 310.816 198.014 278.128 236.09Z",
    fill: "#514EFF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.128 236.09H270.02C302.697 198.014 333.31 156.283 328.808 110.2C325.884 80.3528 305.621 50.6272 270.02 50.6272H278.128C313.73 50.6272 333.992 80.3528 336.916 110.2C341.419 156.283 310.816 198.014 278.128 236.09Z",
    fill: "black"
  }))), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M328.807 110.198C333.311 156.28 302.7 198.015 270.02 236.094C237.38 198.015 206.769 156.28 211.265 110.198C214.196 80.3504 234.449 50.6296 270.02 50.6296C305.624 50.6296 325.884 80.3504 328.807 110.198ZM270.02 143.34C287.846 143.34 302.253 128.711 302.253 110.651C302.253 92.6 287.846 77.9704 270.02 77.9704C252.234 77.9704 237.828 92.6 237.828 110.651C237.828 128.711 252.234 143.34 270.02 143.34Z",
    fill: "#514EFF"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2041 314.963L81.0281 314.769L120.852 314.698L200.5 314.564L280.148 314.698L319.972 314.767L359.796 314.963L319.972 315.159L280.148 315.229L200.5 315.362L120.852 315.228L81.0281 315.158L41.2041 314.963Z",
    fill: "#263238"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M359.938 311.249H41.0605V314.963H359.938V311.249Z",
    fill: "#C7C7C7"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2799 311.249C50.4063 311.868 50.4351 312.487 50.4407 313.106C50.4359 313.725 50.4071 314.344 50.2799 314.962C50.1527 314.343 50.1239 313.724 50.1191 313.106C50.1247 312.487 50.1535 311.868 50.2799 311.249Z",
    fill: "#263238"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0104 311.249C61.1368 311.868 61.1656 312.487 61.1712 313.106C61.1664 313.725 61.1384 314.344 61.0104 314.962C60.8832 314.343 60.8544 313.724 60.8496 313.106C60.8552 312.487 60.8832 311.868 61.0104 311.249Z",
    fill: "#263238"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7399 311.249C71.8663 311.868 71.8951 312.487 71.9007 313.106C71.8959 313.725 71.8679 314.344 71.7399 314.962C71.6127 314.343 71.5839 313.724 71.5791 313.106C71.5847 312.487 71.6135 311.868 71.7399 311.249Z",
    fill: "#263238"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4704 311.249C82.5968 311.868 82.6256 312.487 82.6312 313.106C82.6264 313.725 82.5984 314.344 82.4704 314.962C82.3432 314.343 82.3144 313.724 82.3096 313.106C82.3152 312.487 82.3432 311.868 82.4704 311.249Z",
    fill: "#263238"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1999 311.249C93.3263 311.868 93.3551 312.487 93.3607 313.106C93.3559 313.725 93.3279 314.344 93.1999 314.962C93.0727 314.343 93.0439 313.724 93.0391 313.106C93.0447 312.487 93.0735 311.868 93.1999 311.249Z",
    fill: "#263238"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M103.93 311.249C104.057 311.868 104.086 312.487 104.091 313.106C104.086 313.725 104.058 314.344 103.93 314.962C103.803 314.343 103.774 313.724 103.77 313.106C103.775 312.487 103.803 311.868 103.93 311.249Z",
    fill: "#263238"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M114.66 311.249C114.786 311.868 114.815 312.487 114.821 313.106C114.816 313.725 114.788 314.344 114.66 314.962C114.533 314.343 114.504 313.724 114.499 313.106C114.505 312.487 114.533 311.868 114.66 311.249Z",
    fill: "#263238"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M125.39 311.249C125.517 311.868 125.545 312.487 125.551 313.106C125.546 313.725 125.517 314.344 125.39 314.962C125.263 314.343 125.234 313.724 125.229 313.106C125.235 312.487 125.263 311.868 125.39 311.249Z",
    fill: "#263238"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M136.12 311.249C136.246 311.868 136.275 312.487 136.281 313.106C136.276 313.725 136.247 314.344 136.12 314.962C135.993 314.343 135.964 313.724 135.959 313.106C135.965 312.487 135.993 311.868 136.12 311.249Z",
    fill: "#263238"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M146.85 311.249C146.977 311.868 147.005 312.487 147.011 313.106C147.006 313.725 146.977 314.344 146.85 314.962C146.723 314.343 146.694 313.724 146.689 313.106C146.695 312.487 146.723 311.868 146.85 311.249Z",
    fill: "#263238"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M157.58 311.249C157.706 311.868 157.735 312.487 157.741 313.106C157.736 313.725 157.708 314.344 157.58 314.962C157.453 314.343 157.424 313.724 157.419 313.106C157.425 312.487 157.453 311.868 157.58 311.249Z",
    fill: "#263238"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M168.309 311.249C168.436 311.868 168.464 312.487 168.47 313.106C168.465 313.725 168.437 314.344 168.309 314.962C168.182 314.343 168.153 313.724 168.148 313.106C168.155 312.487 168.183 311.868 168.309 311.249Z",
    fill: "#263238"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M179.04 311.249C179.166 311.868 179.195 312.487 179.201 313.106C179.196 313.725 179.168 314.344 179.04 314.962C178.913 314.343 178.884 313.724 178.879 313.106C178.885 312.487 178.913 311.868 179.04 311.249Z",
    fill: "#263238"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M189.769 311.249C189.896 311.868 189.924 312.487 189.93 313.106C189.925 313.725 189.897 314.344 189.769 314.962C189.642 314.343 189.613 313.724 189.608 313.106C189.615 312.487 189.643 311.868 189.769 311.249Z",
    fill: "#263238"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M200.5 311.249C200.626 311.868 200.655 312.487 200.66 313.106C200.656 313.725 200.628 314.344 200.5 314.962C200.372 314.343 200.344 313.724 200.339 313.106C200.344 312.487 200.373 311.868 200.5 311.249Z",
    fill: "#263238"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M211.229 311.249C211.356 311.868 211.384 312.487 211.39 313.106C211.385 313.725 211.356 314.344 211.229 314.962C211.102 314.343 211.073 313.724 211.068 313.106C211.074 312.487 211.103 311.868 211.229 311.249Z",
    fill: "#263238"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M221.96 311.249C222.086 311.868 222.115 312.487 222.12 313.106C222.116 313.725 222.087 314.344 221.96 314.962C221.832 314.343 221.804 313.724 221.799 313.106C221.804 312.487 221.833 311.868 221.96 311.249Z",
    fill: "#263238"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M232.689 311.249C232.816 311.868 232.844 312.487 232.85 313.106C232.845 313.725 232.816 314.344 232.689 314.962C232.562 314.343 232.533 313.724 232.528 313.106C232.534 312.487 232.563 311.868 232.689 311.249Z",
    fill: "#263238"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M243.42 311.249C243.546 311.868 243.575 312.487 243.58 313.106C243.576 313.725 243.548 314.344 243.42 314.962C243.292 314.343 243.264 313.724 243.259 313.106C243.264 312.487 243.293 311.868 243.42 311.249Z",
    fill: "#263238"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M254.149 311.249C254.275 311.868 254.304 312.487 254.31 313.106C254.305 313.725 254.277 314.344 254.149 314.962C254.022 314.343 253.993 313.724 253.988 313.106C253.994 312.487 254.023 311.868 254.149 311.249Z",
    fill: "#263238"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M264.88 311.249C265.006 311.868 265.035 312.487 265.04 313.106C265.036 313.725 265.008 314.344 264.88 314.962C264.752 314.343 264.724 313.724 264.719 313.106C264.724 312.487 264.753 311.868 264.88 311.249Z",
    fill: "#263238"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M275.61 311.249C275.736 311.868 275.765 312.487 275.771 313.106C275.766 313.725 275.738 314.344 275.61 314.962C275.483 314.343 275.454 313.724 275.449 313.106C275.455 312.487 275.484 311.868 275.61 311.249Z",
    fill: "#263238"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M286.34 311.249C286.466 311.868 286.495 312.487 286.5 313.106C286.496 313.725 286.468 314.344 286.34 314.962C286.212 314.343 286.184 313.724 286.179 313.106C286.184 312.487 286.212 311.868 286.34 311.249Z",
    fill: "#263238"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M297.07 311.249C297.196 311.868 297.225 312.487 297.231 313.106C297.226 313.725 297.197 314.344 297.07 314.962C296.943 314.343 296.914 313.724 296.909 313.106C296.915 312.487 296.944 311.868 297.07 311.249Z",
    fill: "#263238"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M307.799 311.249C307.926 311.868 307.955 312.487 307.96 313.106C307.955 313.725 307.927 314.344 307.799 314.962C307.672 314.343 307.643 313.724 307.639 313.106C307.644 312.487 307.672 311.868 307.799 311.249Z",
    fill: "#263238"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M318.53 311.249C318.656 311.868 318.685 312.487 318.691 313.106C318.686 313.725 318.657 314.344 318.53 314.962C318.403 314.343 318.374 313.724 318.369 313.106C318.375 312.487 318.404 311.868 318.53 311.249Z",
    fill: "#263238"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M329.26 311.249C329.387 311.868 329.416 312.487 329.421 313.106C329.416 313.725 329.388 314.344 329.26 314.962C329.133 314.343 329.104 313.724 329.1 313.106C329.105 312.487 329.133 311.868 329.26 311.249Z",
    fill: "#263238"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M339.99 311.249C340.116 311.868 340.145 312.487 340.151 313.106C340.146 313.725 340.118 314.344 339.99 314.962C339.863 314.343 339.834 313.724 339.829 313.106C339.835 312.487 339.863 311.868 339.99 311.249Z",
    fill: "#263238"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M350.72 311.249C350.847 311.868 350.876 312.487 350.881 313.106C350.876 313.725 350.848 314.344 350.72 314.962C350.593 314.343 350.564 313.724 350.56 313.106C350.565 312.487 350.593 311.868 350.72 311.249Z",
    fill: "#263238"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4614 311.249H56.875C56.875 311.249 56.9158 308.631 58.6446 307.937C60.3734 307.242 61.4014 308.598 61.4014 308.598C61.4014 308.598 62.107 303.785 65.3286 303.785C68.5502 303.785 70.0926 307.937 70.0926 307.937C70.0926 307.937 70.8142 306.682 72.603 306.915C74.3902 307.149 74.4614 311.249 74.4614 311.249Z",
    fill: "#37474F"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M357.19 311.249C357.19 311.249 356.65 308.734 355.574 308.346C354.497 307.958 353.842 309.087 353.842 309.087C353.842 309.087 353.588 306.684 352.062 305.964C350.535 305.245 349.389 306.718 349.389 306.718C349.389 306.718 348.218 303.667 346.124 303.667C344.031 303.667 342.975 308.13 342.975 308.13C342.975 308.13 341.741 306.8 340.474 307.55C339.208 308.302 339.208 311.247 339.208 311.247H357.19V311.249Z",
    fill: "#37474F"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M192.972 311.249C192.972 311.249 192.433 308.734 191.356 308.346C190.279 307.958 189.624 309.087 189.624 309.087C189.624 309.087 189.37 306.684 187.844 305.964C186.317 305.245 185.171 306.718 185.171 306.718C185.171 306.718 184 303.667 181.906 303.667C179.813 303.667 178.757 308.13 178.757 308.13C178.757 308.13 177.522 306.8 176.257 307.55C174.99 308.302 174.99 311.247 174.99 311.247H192.972V311.249Z",
    fill: "#37474F"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0273 311.249H43.8105C43.8105 311.249 44.3449 308.962 45.4201 308.801C46.4953 308.639 46.9953 309.699 46.9953 309.699C46.9953 309.699 46.9465 306.51 48.9553 305.967C50.9633 305.424 52.6481 308.242 52.6481 308.242C52.6481 308.242 53.9073 306.635 55.6233 306.738C57.3393 306.842 57.7753 309.495 57.7753 309.495C57.7753 309.495 59.3369 308.574 60.0273 311.249Z",
    fill: "#455A64"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M178.486 311.249H162.27C162.27 311.249 162.804 308.962 163.879 308.801C164.954 308.639 165.454 309.699 165.454 309.699C165.454 309.699 165.406 306.51 167.414 305.967C169.422 305.424 171.107 308.242 171.107 308.242C171.107 308.242 172.366 306.635 174.082 306.738C175.798 306.842 176.234 309.495 176.234 309.495C176.234 309.495 177.796 308.574 178.486 311.249Z",
    fill: "#455A64"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M340.37 311.249H330.407C330.407 311.249 330.43 309.766 331.41 309.373C332.389 308.979 332.971 309.747 332.971 309.747C332.971 309.747 333.37 307.021 335.196 307.021C337.022 307.021 337.895 309.373 337.895 309.373C337.895 309.373 338.304 308.662 339.318 308.794C340.33 308.926 340.37 311.249 340.37 311.249Z",
    fill: "#455A64"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M218.473 311.249H208.51C208.51 311.249 208.533 309.766 209.512 309.373C210.491 308.979 211.074 309.747 211.074 309.747C211.074 309.747 211.473 307.021 213.299 307.021C215.124 307.021 215.998 309.373 215.998 309.373C215.998 309.373 216.407 308.662 217.42 308.794C218.432 308.926 218.473 311.249 218.473 311.249Z",
    fill: "#455A64"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M177.189 354.325C175.324 354.927 122.132 354.25 120.124 352.936C119.353 352.45 119 344.694 118.842 335.31C118.841 335.211 118.84 335.114 118.84 335.015C118.803 333.082 118.777 331.09 118.774 329.071C118.773 328.794 118.772 328.515 118.764 328.238L121.339 300.643L156.921 300.991L153.416 328.328L153.375 329.41L153.161 335.069L153.14 335.651C153.14 335.651 173.384 345.018 175.441 346.694C177.482 348.366 179.056 353.731 177.189 354.325Z",
    fill: "#DD6A57"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M177.189 354.325C175.324 354.927 122.132 354.25 120.124 352.936C119.353 352.45 119 344.694 118.842 335.31C118.841 335.211 118.84 335.114 118.84 335.015C118.803 333.082 118.777 331.09 118.774 329.071C118.773 328.794 118.772 328.515 118.764 328.238L153.416 328.328L153.375 329.41L153.161 335.069L153.14 335.651C153.14 335.651 173.384 345.018 175.441 346.694C177.482 348.366 179.056 353.731 177.189 354.325Z",
    fill: "#EBEBEB"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M177.195 354.322C176.235 354.631 161.784 354.602 147.658 354.32C144.818 354.264 141.994 354.199 139.301 354.126C129.227 353.852 120.903 353.439 120.13 352.934C119.365 352.454 119.013 344.912 118.857 335.701C118.857 335.57 118.849 335.44 118.849 335.31C118.849 335.213 118.849 335.107 118.841 335.01H118.882L153.162 335.067L153.146 335.653C153.146 335.653 173.394 345.014 175.444 346.69C177.486 348.366 179.058 353.727 177.195 354.322Z",
    fill: "#514EFF"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M176.614 352.255C167.65 351.921 131.465 351.418 122.579 351.769C122.507 351.772 122.506 351.821 122.578 351.826C131.456 352.351 167.644 352.561 176.612 352.403C176.801 352.399 176.803 352.263 176.614 352.255Z",
    fill: "#263238"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M156.981 335.217C153.461 334.514 149.139 335 146.411 337.479C146.305 337.575 146.443 337.724 146.558 337.69C150.053 336.637 153.312 335.974 156.962 335.662C157.219 335.641 157.233 335.267 156.981 335.217Z",
    fill: "#263238"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M159.508 336.784C155.988 336.081 151.666 336.567 148.938 339.047C148.832 339.143 148.971 339.291 149.085 339.257C152.58 338.204 155.84 337.541 159.489 337.23C159.746 337.208 159.76 336.834 159.508 336.784Z",
    fill: "#263238"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M162.036 338.352C158.516 337.648 154.193 338.135 151.465 340.614C151.36 340.71 151.497 340.859 151.613 340.825C155.108 339.772 158.368 339.109 162.017 338.798C162.273 338.775 162.288 338.402 162.036 338.352Z",
    fill: "#263238"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M147.658 354.32C144.818 354.264 141.994 354.199 139.301 354.126C129.227 353.852 120.903 353.439 120.13 352.934C119.365 352.454 119.013 344.912 118.857 335.701C118.857 335.57 118.849 335.44 118.849 335.31C118.849 335.213 118.849 335.107 118.841 335.01H118.882C123.577 338.304 140.13 349.318 147.658 354.32Z",
    fill: "#263238"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M155.211 335.188L116.902 335.197C116.902 335.197 124.596 245.721 124.294 244.159C123.911 242.158 121.647 233.102 118.634 221.271C117.689 217.569 116.671 213.598 115.613 209.482C112.754 198.351 109.602 186.187 106.858 175.602C102.737 159.744 99.5205 147.425 99.5205 147.425L131.987 147.418C131.987 147.418 135.773 159.41 140.545 175.017C148.322 200.378 158.713 235.283 159.74 243.77C161.402 257.471 155.211 335.188 155.211 335.188Z",
    fill: "#455A64"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M153.512 328.653C147.661 328.532 149.342 328.485 143.49 328.43C140.626 328.402 121.809 328.243 119.134 328.686C119.075 328.696 119.075 328.796 119.134 328.806C121.809 329.248 140.626 329.08 143.49 329.052C149.341 328.994 147.661 328.947 153.511 328.824C153.622 328.821 153.622 328.655 153.512 328.653Z",
    fill: "#263238"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M131.501 238.689C130.243 233.151 128.366 227.725 126.731 222.29C123.407 211.246 120.058 200.21 116.702 189.176C115.024 183.659 113.343 178.143 111.645 172.632C110.787 169.85 109.931 167.066 109.059 164.288C108.206 161.57 107.235 158.874 106.466 156.13C106.153 155.014 105.982 155.628 106.383 157.045C107.191 159.902 107.99 162.762 108.823 165.612C110.475 171.256 112.139 176.897 113.809 182.535C117.132 193.758 120.501 204.967 123.866 216.178C125.553 221.798 127.251 227.415 128.941 233.035C129.748 235.721 130.539 238.422 131.014 241.19C131.509 244.077 131.536 246.997 131.354 249.914C130.987 255.775 130.31 261.628 129.771 267.476C129.23 273.336 128.688 279.196 128.147 285.055C127.071 296.717 125.993 308.378 124.946 320.042C124.813 321.521 124.684 322.999 124.571 324.479C124.532 324.974 125.281 324.937 125.333 324.46C126.592 312.929 127.557 301.36 128.637 289.81C129.712 278.318 130.787 266.826 131.858 255.334C132.127 252.448 132.433 249.558 132.435 246.657C132.437 243.966 132.097 241.311 131.501 238.689Z",
    fill: "#263238"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M128.3 147.418C126.051 164.856 121.761 197.551 118.634 221.271C111.304 192.533 99.5195 147.424 99.5195 147.424L128.3 147.418Z",
    fill: "#263238"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M135.914 354.847C134.05 355.457 80.8567 354.973 78.8447 353.667C78.0711 353.184 77.6903 345.429 77.4983 336.046C77.4975 335.948 77.4959 335.85 77.4951 335.752C77.4511 333.818 77.4183 331.827 77.4079 329.809C77.4063 329.53 77.4047 329.253 77.3943 328.976C77.2671 315.434 78.2407 301.381 78.2407 301.381L113.01 301.599L112.045 328.938L112.009 330.021L111.816 335.68L111.797 336.262C111.797 336.262 132.076 345.554 134.138 347.224C136.185 348.886 137.778 354.246 135.914 354.847Z",
    fill: "#DD6A57"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M135.915 354.847C134.051 355.457 80.8569 354.973 78.8449 353.667C78.0713 353.184 77.6905 345.429 77.4985 336.045C77.4977 335.948 77.4961 335.849 77.4953 335.752C77.4513 333.818 77.4185 331.827 77.4081 329.809C77.4065 329.53 77.4049 329.253 77.3945 328.976L112.047 328.939L112.01 330.021L111.817 335.681L111.799 336.263C111.799 336.263 132.077 345.555 134.139 347.225C136.185 348.885 137.779 354.245 135.915 354.847Z",
    fill: "#EBEBEB"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M135.914 354.847C134.05 355.457 80.8567 354.973 78.8447 353.667C78.0711 353.184 77.6903 345.429 77.4983 336.046C77.4975 335.948 77.4959 335.85 77.4951 335.752L111.817 335.681L111.798 336.263C111.798 336.263 132.077 345.555 134.139 347.225C136.185 348.886 137.778 354.246 135.914 354.847Z",
    fill: "#514EFF"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M135.331 352.778C126.366 352.477 90.1794 352.106 81.2946 352.489C81.2226 352.492 81.2218 352.541 81.2938 352.545C90.173 353.038 126.362 353.115 135.33 352.925C135.519 352.922 135.52 352.786 135.331 352.778Z",
    fill: "#263238"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M115.636 335.812C112.114 335.122 107.793 335.624 105.074 338.114C104.968 338.21 105.107 338.358 105.222 338.323C108.713 337.258 111.97 336.582 115.618 336.258C115.875 336.235 115.888 335.862 115.636 335.812Z",
    fill: "#263238"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M118.169 337.37C114.647 336.68 110.326 337.182 107.607 339.671C107.501 339.768 107.64 339.916 107.755 339.881C111.246 338.815 114.504 338.14 118.151 337.815C118.408 337.794 118.422 337.42 118.169 337.37Z",
    fill: "#263238"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M120.701 338.929C117.179 338.238 112.858 338.741 110.139 341.23C110.033 341.326 110.173 341.475 110.287 341.44C113.778 340.374 117.036 339.699 120.683 339.374C120.941 339.351 120.954 338.978 120.701 338.929Z",
    fill: "#263238"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M130.937 147.417C130.937 147.417 130.191 162.95 126.639 175.254C126.354 176.271 126.045 177.272 125.711 178.233C125.711 178.233 122.01 179.576 116.355 183.044C116.355 183.044 115.984 195.542 115.613 209.482C115.202 225.064 114.775 242.445 114.865 246.13C115.194 259.922 113.16 335.759 113.16 335.759L74.8594 335.922C74.8594 335.922 81.765 251.231 81.7154 246.178C81.6402 238.058 83.561 202.165 85.0442 175.988C85.9522 159.86 86.6978 147.427 86.6978 147.427L130.937 147.417Z",
    fill: "#455A64"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M111.845 328.946C105.994 328.85 107.674 328.796 101.822 328.766C98.9583 328.75 80.1407 328.671 77.4679 329.126C77.4087 329.137 77.4095 329.236 77.4679 329.246C80.1455 329.677 98.9615 329.429 101.825 329.388C107.676 329.306 105.995 329.266 111.845 329.118C111.955 329.114 111.955 328.948 111.845 328.946Z",
    fill: "#263238"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9167 152.977C89.2167 174.346 88.4743 195.716 87.5231 217.075C86.5687 238.508 85.2815 259.933 83.4935 281.313C82.4943 293.258 81.5535 310.06 80.2671 321.978C80.2583 322.058 80.3807 322.086 80.3911 322.005C83.1751 300.807 84.7239 274.597 86.0903 253.266C87.4567 231.938 88.3815 210.573 89.1039 189.214C89.5127 177.132 89.8239 165.046 90.1831 152.963C90.1879 152.79 89.9223 152.806 89.9167 152.977Z",
    fill: "#263238"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M127.303 177.307C123.49 178.822 119.838 180.892 116.355 183.045C116.218 183.129 116.321 183.342 116.47 183.27C120.165 181.474 123.937 179.745 127.528 177.748C127.81 177.591 127.596 177.191 127.303 177.307Z",
    fill: "#263238"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M127.515 164.128C127.262 165.49 126.933 166.837 126.639 168.19C126.364 169.46 126.161 170.755 125.826 172.01C125.5 173.228 124.982 174.343 124.047 175.213C123.549 175.676 123.001 176.086 122.47 176.51C122.183 176.738 121.874 176.958 121.577 177.19C121.615 177.01 121.646 176.827 121.679 176.642C121.77 176.126 121.857 175.609 121.943 175.092C122.135 173.946 122.318 172.797 122.494 171.648C122.839 169.389 123.157 167.106 123.627 164.87C123.646 164.778 123.51 164.744 123.486 164.834C122.924 167.05 122.303 169.243 121.814 171.478C121.574 172.574 120.717 177.986 120.679 178.369C120.64 178.764 120.607 179.161 120.593 179.558C120.579 179.95 120.502 180.389 120.592 180.774C120.615 180.872 120.734 180.856 120.776 180.79C120.778 180.791 120.78 180.792 120.782 180.794C120.978 180.449 121.027 179.998 121.126 179.618C121.225 179.231 121.312 178.839 121.382 178.447C121.406 178.306 121.426 178.161 121.446 178.016C121.979 177.692 122.475 177.263 122.974 176.902C123.51 176.514 124.058 176.134 124.566 175.706C125.538 174.887 126.146 173.883 126.509 172.67C126.885 171.41 127 170.081 127.146 168.781C127.317 167.243 127.442 165.697 127.657 164.165C127.669 164.073 127.533 164.035 127.515 164.128Z",
    fill: "#263238"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M117.144 107.348C119.267 113.268 126.753 126.548 138.223 137.01C142.656 141.046 175.688 138.396 178.962 137.119C181.253 136.226 185.521 119.573 183.116 118.07C178.606 115.252 149.074 121.757 147.818 121.094C145.9 120.072 133.184 111.55 124.995 103.453C119.021 97.5527 113.623 97.4943 117.144 107.348Z",
    fill: "#DD6A57"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M125.633 124.852L144.374 117.407C144.374 117.407 127.558 102.95 121.412 100.094C114.496 96.8792 114.365 101.118 116.795 107.949C119.225 114.778 125.633 124.852 125.633 124.852Z",
    fill: "#37474F"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M140.417 115.127C139.729 115.284 133.852 117.513 132.585 118.025C131.317 118.537 126.119 120.579 124.855 121.218C124.799 121.246 124.825 121.33 124.888 121.312C126.242 120.925 131.492 118.879 132.793 118.385C134.093 117.89 139.86 115.556 140.458 115.212C140.509 115.182 140.463 115.116 140.417 115.127Z",
    fill: "#263238"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M132.86 121.976L125.636 124.848C125.636 124.848 119.228 114.776 116.796 107.952C115.02 102.96 114.612 99.3439 117.22 99.0239L132.86 121.976Z",
    fill: "#263238"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4171 164.328C82.5395 164.466 135.527 164.81 136.012 164.268C136.689 163.504 124.923 106.054 119.51 98.9424C118.351 97.4216 111.046 95.3512 106.803 98.8064C97.7971 106.14 89.9763 131.323 88.1659 138.923C85.1651 151.445 81.9819 163.829 82.4171 164.328Z",
    fill: "#514EFF"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M119.81 99.3911H106.13C106.354 99.1831 106.578 98.9911 106.802 98.8071C106.938 98.6951 107.082 98.5911 107.226 98.4951H119.01C119.226 98.6471 119.394 98.7991 119.506 98.9431C119.61 99.0711 119.706 99.2231 119.81 99.3911Z",
    fill: "black"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M121.091 101.967H103.771C104.019 101.655 104.266 101.351 104.522 101.063H120.698C120.826 101.343 120.955 101.647 121.091 101.967Z",
    fill: "black"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M122.082 104.543H101.914C102.122 104.231 102.322 103.935 102.53 103.639H121.754C121.858 103.927 121.97 104.231 122.082 104.543Z",
    fill: "black"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M122.954 107.111H100.338C100.514 106.807 100.69 106.503 100.874 106.207H122.658C122.762 106.503 122.858 106.807 122.954 107.111Z",
    fill: "black"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M123.771 109.687H98.9307C99.0907 109.383 99.2427 109.079 99.4107 108.783H123.491C123.579 109.079 123.675 109.383 123.771 109.687Z",
    fill: "black"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M124.531 112.263H97.6426C97.7866 111.959 97.9306 111.655 98.0826 111.359H124.267C124.355 111.655 124.443 111.959 124.531 112.263Z",
    fill: "black"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M125.258 114.831H96.458C96.594 114.527 96.73 114.231 96.866 113.927H125.002C125.09 114.223 125.17 114.527 125.258 114.831Z",
    fill: "black"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M125.955 117.407H95.3467C95.4747 117.103 95.6027 116.799 95.7307 116.503H125.715C125.795 116.799 125.875 117.103 125.955 117.407Z",
    fill: "black"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M126.635 119.983H94.3066C94.4186 119.679 94.5386 119.383 94.6666 119.079H126.403C126.475 119.375 126.555 119.679 126.635 119.983Z",
    fill: "black"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M127.29 122.551H93.3145C93.4265 122.247 93.5385 121.951 93.6585 121.647H127.066C127.138 121.951 127.218 122.247 127.29 122.551Z",
    fill: "black"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M127.938 125.127H92.3779C92.4819 124.823 92.5939 124.527 92.7059 124.223H127.714C127.786 124.527 127.858 124.823 127.938 125.127Z",
    fill: "black"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M128.562 127.695H91.4902C91.5862 127.399 91.6902 127.095 91.8022 126.799H128.346C128.418 127.095 128.49 127.399 128.562 127.695Z",
    fill: "black"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M129.179 130.271H90.6426C90.7386 129.975 90.8346 129.671 90.9306 129.367H128.963C129.035 129.671 129.107 129.967 129.179 130.271Z",
    fill: "black"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M129.779 132.847H89.8428C89.9308 132.551 90.0188 132.247 90.1148 131.943H129.579C129.643 132.247 129.715 132.551 129.779 132.847Z",
    fill: "black"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M130.379 135.415H89.0908C89.1708 135.127 89.2588 134.831 89.3468 134.519H130.171C130.235 134.823 130.307 135.119 130.379 135.415Z",
    fill: "black"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M130.955 137.991H88.3945C88.4665 137.711 88.5465 137.407 88.6265 137.087H130.755C130.819 137.391 130.891 137.687 130.955 137.991Z",
    fill: "black"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M131.531 140.567H87.7705C87.8425 140.271 87.9145 139.967 87.9865 139.663H131.331C131.395 139.967 131.459 140.271 131.531 140.567Z",
    fill: "black"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M132.09 143.135H87.1465C87.2185 142.839 87.2905 142.543 87.3625 142.239H131.898C131.962 142.535 132.026 142.839 132.09 143.135Z",
    fill: "black"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M132.634 145.711H86.5225C86.5945 145.407 86.6665 145.111 86.7385 144.807H132.442C132.514 145.111 132.578 145.407 132.634 145.711Z",
    fill: "black"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M133.178 148.287H85.8984C85.9704 147.991 86.0424 147.687 86.1144 147.383H132.994C133.058 147.687 133.122 147.991 133.178 148.287Z",
    fill: "black"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M133.706 150.855H85.2744C85.3464 150.559 85.4184 150.255 85.4904 149.951H133.522C133.586 150.255 133.65 150.559 133.706 150.855Z",
    fill: "black"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M134.227 153.431H84.6426C84.7226 153.135 84.7946 152.831 84.8666 152.527H134.043C134.107 152.831 134.171 153.135 134.227 153.431Z",
    fill: "black"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M134.73 156.007H84.0342C84.1062 155.711 84.1702 155.415 84.2502 155.103H134.554C134.61 155.415 134.674 155.711 134.73 156.007Z",
    fill: "black"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M135.211 158.575H83.4346C83.4986 158.279 83.5706 157.983 83.6426 157.671H135.043C135.099 157.983 135.155 158.279 135.211 158.575Z",
    fill: "black"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M135.658 161.151H82.8662C82.9222 160.871 82.9862 160.567 83.0662 160.247H135.506C135.562 160.567 135.61 160.863 135.658 161.151Z",
    fill: "black"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M136.026 163.727H82.4023C82.4263 163.487 82.4743 163.183 82.5383 162.823H135.914C135.97 163.191 136.002 163.495 136.026 163.727Z",
    fill: "black"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M122.075 165.836L130.551 129.616L133.888 97.14L151.457 101.807L166.146 98.8648L179.273 104.48L197.97 100.249L185.326 134.541L179.998 169.272L165.857 172.772L151.641 166.668L137.234 171.386L122.075 165.836Z",
    fill: "#EBEBEB"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M137.233 171.386L151.457 101.807L166.145 98.8649L151.641 166.668L137.233 171.386Z",
    fill: "#DBDBDB"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M165.856 172.772L179.272 104.48L197.969 100.249L185.326 134.541L179.997 169.272L165.856 172.772Z",
    fill: "#DBDBDB"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M194.452 115.768C195.034 119.21 197.597 124.006 197.193 126.57C196.829 128.885 194.747 129.146 194.747 129.146C194.747 129.146 196.872 131.078 196.122 133.345C195.737 134.51 193.535 134.918 193.535 134.918C193.535 134.918 195.17 136.542 194.38 138.516C193.75 140.089 191.638 140.262 191.638 140.262C191.638 140.262 192.481 142.55 191.326 143.947C188.982 146.779 174.986 142.822 174.282 137.055C173.954 134.367 177.32 135.52 177.32 135.52C177.32 135.52 172.88 132.694 173.622 129.788C174.363 126.882 178.646 128.642 178.646 128.642C178.646 128.642 174.368 125.866 175.441 122.931C176.558 119.875 180.541 122.37 180.541 122.37C180.541 122.37 178.025 119.381 179.362 117.322C181.568 113.922 187.308 120.587 190.59 120.727L192.265 115.809L194.452 115.768Z",
    fill: "#DD6A57"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M195.714 120.869C195.447 117.562 197.973 116.883 198.606 113.741C199.309 110.25 195.015 109.999 192.32 115.634L190.588 120.727L195.714 120.869Z",
    fill: "#DD6A57"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M191.308 140.338C191.355 140.348 191.352 140.417 191.301 140.414C186.381 140.234 181.029 138.529 177.127 135.478C176.999 135.378 177.106 135.127 177.268 135.21C181.892 137.586 186.185 139.324 191.308 140.338Z",
    fill: "#263238"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M193.595 134.967C193.651 134.978 193.634 135.07 193.573 135.068C188.503 134.855 182.53 132.769 178.445 128.723C178.305 128.585 178.318 128.319 178.491 128.467C181.411 130.95 188.978 134.078 193.595 134.967Z",
    fill: "#263238"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M180.333 121.982C184.4 125.71 189.252 127.759 194.538 129.147C194.607 129.165 194.574 129.261 194.512 129.262C191.741 129.287 188.464 128.051 185.996 126.874C183.631 125.746 181.724 124.253 180.203 122.125C180.144 122.042 180.247 121.902 180.333 121.982Z",
    fill: "#263238"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7084 103.533C90.3828 113.874 72.3036 140.557 75.7796 147.637C80.4628 157.177 98.2196 171.402 104.576 173.725C107.32 174.728 119.123 154.844 116.588 153.018C113.548 150.829 96.6548 138.807 96.8212 137.681C96.9796 136.609 102.298 123.556 105.199 112.096C108.564 98.8033 104.829 97.8553 99.7084 103.533Z",
    fill: "#DD6A57"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M105.056 151.141C105.056 151.141 113.635 148.829 119.316 147.58C122.486 146.883 128.027 146.174 130.589 146.728C134.422 147.556 149.924 153.466 148.572 157.256C147.348 160.686 134.675 153.918 134.675 153.918C134.675 153.918 148.067 159.618 145.834 163.477C143.601 167.336 130.299 157.784 130.299 157.784C130.299 157.784 143.927 163.949 140.995 167.564C138.779 170.296 126.244 162.324 126.244 162.324C126.244 162.324 137.921 167.704 135.763 170.612C133.378 173.826 121.346 167.193 121.346 167.193C114.616 173.662 108.575 174.883 104.576 173.726C103.6 173.442 105.056 151.141 105.056 151.141Z",
    fill: "#DD6A57"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M130.168 151.649C131.765 152.262 133.386 152.871 134.924 153.623C136.461 154.376 137.973 155.183 139.434 156.075C143.017 158.263 144.917 160.194 144.787 160.087C141.703 157.569 136.241 154.79 134.703 154.037C133.169 153.286 131.673 152.458 130.138 151.706C130.099 151.687 130.13 151.634 130.168 151.649Z",
    fill: "#263238"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M127.35 157.15C129.356 158.021 131.379 158.811 133.347 159.771C135.305 160.726 137.08 161.803 138.967 162.89C139.113 162.974 139.02 163.024 138.87 162.946C136.941 161.935 135.079 161.15 133.138 160.162C131.204 159.177 129.293 158.11 127.325 157.197C127.295 157.182 127.32 157.138 127.35 157.15Z",
    fill: "#263238"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M124.083 161.438C127.217 162.612 130.13 164.362 132.946 166.147C133.086 166.236 132.96 166.288 132.811 166.206C129.894 164.585 127.617 163.293 124.042 161.548C123.985 161.52 124.017 161.413 124.083 161.438Z",
    fill: "#263238"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M101.44 126.077L81.6631 122.138C81.6631 122.138 95.5919 104.882 101.121 100.962C107.343 96.5521 108.237 100.698 107.081 107.854C105.924 115.012 101.44 126.077 101.44 126.077Z",
    fill: "#37474F"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M101.616 122.623C100.951 122.386 94.7974 121.108 93.4542 120.859C92.1102 120.61 86.6286 119.541 85.2198 119.399C85.1574 119.393 85.135 119.478 85.1966 119.496C86.547 119.898 92.0734 120.992 93.4366 121.274C94.7998 121.555 100.917 122.684 101.606 122.716C101.664 122.719 101.661 122.639 101.616 122.623Z",
    fill: "#263238"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M113.073 94.9632C108.714 94.4752 103.508 98.2048 107.361 103.259C111.214 108.314 115.398 109.285 117.666 108.58C120.397 107.731 121.414 102.206 120.737 99.6072C120.06 97.008 116.794 95.38 113.073 94.9632Z",
    fill: "#455A64"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M116.66 106.759C114.836 107.031 109.481 103.696 107.454 100.093C107.316 99.8448 108.233 89.888 108.21 87.8968C108.203 87.488 120.738 90.7864 120.738 90.7864C120.738 90.7864 119.558 94.976 119.62 98.4488C119.628 98.7392 119.66 99.0088 119.715 99.2656C119.72 99.3032 119.731 99.3488 119.735 99.4008C120.006 100.95 119.334 106.36 116.66 106.759Z",
    fill: "#DD6A57"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M109.016 87.9504C109.52 90.9664 111.544 99.4064 118.456 99.4864C118.92 99.4864 119.344 99.4624 119.736 99.3984C119.728 99.3504 119.72 99.3024 119.712 99.2624C119.664 99.0064 119.632 98.7344 119.624 98.4464C119.56 94.9744 120.736 90.7824 120.736 90.7824C120.736 90.7824 111.792 88.4304 109.016 87.9504Z",
    fill: "#263238"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M126.531 68.5944C126.531 68.5944 130.306 71.108 130.238 75.4312C130.17 79.7544 128.358 83.9456 127.954 84.088C127.551 84.2312 126.531 68.5944 126.531 68.5944Z",
    fill: "#263238"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M109.424 71.06C107.185 75.1144 106.824 88.1184 109.316 91.5624C112.929 96.5552 120.164 98.4896 124.739 93.8456C129.173 89.344 129.344 72.388 126.436 69.1224C122.156 64.3128 112.732 65.0712 109.424 71.06Z",
    fill: "#DD6A57"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M120.039 81.4095C120.034 81.3759 119.97 81.4487 119.97 81.4847C119.969 82.3615 119.82 83.3655 119.019 83.6303C118.994 83.6383 118.995 83.6823 119.024 83.6799C119.996 83.5751 120.179 82.2407 120.039 81.4095Z",
    fill: "#263238"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M119.288 80.4703C117.883 80.3175 117.681 83.1391 118.982 83.2807C120.263 83.4191 120.466 80.5983 119.288 80.4703Z",
    fill: "#263238"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M124.861 81.6927C124.87 81.6599 124.927 81.7391 124.923 81.7743C124.832 82.6463 124.875 83.6599 125.645 84.0071C125.669 84.0175 125.663 84.0615 125.635 84.0551C124.679 83.8511 124.635 82.5047 124.861 81.6927Z",
    fill: "#263238"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M125.707 80.8359C127.121 80.8303 127.028 83.6575 125.719 83.6623C124.43 83.6679 124.522 80.8407 125.707 80.8359Z",
    fill: "#263238"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M118.09 79.5312C118.481 79.4624 118.831 79.3328 119.21 79.2248C119.639 79.1024 119.993 79.0496 120.293 78.6944C120.454 78.504 120.419 78.1392 120.249 77.9656C119.853 77.5608 119.291 77.58 118.769 77.7064C118.203 77.8432 117.801 78.0936 117.449 78.5568C117.109 79.0048 117.574 79.6224 118.09 79.5312Z",
    fill: "#263238"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M126.903 78.8728C126.516 78.7808 126.175 78.632 125.802 78.5015C125.381 78.3543 125.031 78.2808 124.751 77.9088C124.601 77.7096 124.658 77.3471 124.838 77.1831C125.257 76.8015 125.817 76.8544 126.331 77.0104C126.888 77.18 127.275 77.4535 127.599 77.9359C127.914 78.4047 127.413 78.9944 126.903 78.8728Z",
    fill: "#263238"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M118.422 89.2408C118.616 89.46 118.805 89.7576 119.12 89.8064C119.423 89.8536 119.789 89.7424 120.076 89.6536C120.104 89.6448 120.13 89.676 120.11 89.7008C119.859 90.02 119.367 90.196 118.967 90.096C118.576 89.9984 118.405 89.6424 118.335 89.2736C118.326 89.2232 118.394 89.2088 118.422 89.2408Z",
    fill: "#263238"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M119.528 86.6904C119.963 87.484 120.652 87.9504 121.419 88.1568C121.761 88.2512 122.125 88.2896 122.486 88.2824C122.557 88.2856 122.628 88.2832 122.693 88.2736C122.757 88.2704 122.815 88.2672 122.886 88.2576C122.989 88.2504 123.051 88.1696 123.076 88.0744V88.068C123.077 88.036 123.079 88.0104 123.074 87.9776C123.074 87.9776 123.074 87.9776 123.075 87.9712L123.079 87.8944C123.145 87.2232 123.154 86.1944 123.154 86.1944C123.391 86.3352 124.605 86.9888 124.61 86.636C124.645 83.7128 124.684 80.4624 124.101 77.5464C124.087 77.4496 123.939 77.4608 123.941 77.5576C123.796 80.3656 124.145 83.1792 124.045 86.0024C123.656 85.8216 123.024 85.4936 122.671 85.4752C122.573 85.496 122.691 87.4624 122.637 87.7616C122.637 87.7616 122.636 87.7744 122.629 87.7936C121.488 87.8568 120.66 87.4544 119.617 86.616C119.554 86.5632 119.481 86.6168 119.528 86.6904Z",
    fill: "#263238"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M122.114 87.9127C122.114 87.9127 121.46 88.6751 120.622 88.9071C120.313 88.9935 119.986 89.0127 119.653 88.8983C118.968 88.6647 118.997 88.0231 119.164 87.4839C119.3 87.0407 119.537 86.6671 119.537 86.6671C119.537 86.6671 120.487 87.6943 122.114 87.9127Z",
    fill: "#263238"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M120.621 88.9071C120.312 88.9935 119.985 89.0127 119.652 88.8983C118.968 88.6647 118.996 88.0231 119.164 87.4839C119.906 87.6143 120.61 88.1751 120.621 88.9071Z",
    fill: "#FF9CBD"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M107.879 83.2976C109.431 83.812 111.335 79.152 111.884 77.356C112.368 75.7728 112.997 70.7328 113.081 70.3896C113.165 70.0472 119.796 75.0128 123.761 73.9504C127.727 72.8872 130.44 69.4104 130.531 67.7616C130.622 66.1128 125.824 61.8136 121.596 61.5048C117.368 61.196 111.517 66.4472 111.517 66.4472C111.517 66.4472 113.516 64.1664 113.454 63.9744C113.392 63.7816 110.632 64.8136 110.086 66.7504C110.086 66.7504 110.682 64.3168 110.476 64.2664C110.271 64.216 108.098 66.2632 108.543 67.8616C108.543 67.8616 106.036 69.936 105.756 72.2648C105.476 74.5944 106.055 82.6936 107.879 83.2976Z",
    fill: "#263238"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M126.58 73.1904C125.369 73.7144 124.156 74.2936 122.828 74.4392C121.392 74.596 119.916 74.2032 118.595 73.6632C117.244 73.1112 116.023 72.3264 114.919 71.3744C113.952 70.5408 113.1 69.5432 112.064 68.7968C111.804 68.6104 111.491 68.9824 111.648 69.228C113.192 71.6608 115.973 73.7256 118.679 74.6504C121.525 75.6232 124.234 75.044 126.594 73.2224C126.608 73.2112 126.6 73.1816 126.58 73.1904Z",
    fill: "#263238"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M117.653 86.0617C115.948 85.7849 114.576 84.3801 114.417 82.5817C114.229 80.4545 115.805 78.5721 117.932 78.3833C120.059 78.1945 121.941 79.7713 122.13 81.8977C122.318 84.0233 120.741 85.9065 118.616 86.0953C118.286 86.1257 117.964 86.1129 117.653 86.0617ZM118.81 78.9289C118.541 78.8849 118.261 78.8737 117.977 78.8993C116.136 79.0625 114.769 80.6937 114.932 82.5361C115.096 84.3777 116.728 85.7457 118.569 85.5809C120.411 85.4177 121.777 83.7857 121.614 81.9441C121.476 80.3865 120.288 79.1689 118.81 78.9289Z",
    fill: "#514EFF"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M126.531 86.4065C125.069 86.1689 123.986 84.4561 124.074 82.4385C124.119 81.4201 124.452 80.4721 125.011 79.7705C125.589 79.0441 126.34 78.6625 127.125 78.6977C127.913 78.7305 128.624 79.1777 129.136 79.9521C129.631 80.7009 129.878 81.6737 129.834 82.6921C129.739 84.8249 128.371 86.5033 126.784 86.4329C126.698 86.4281 126.614 86.4201 126.531 86.4065ZM127.297 79.2345C127.232 79.2241 127.167 79.2169 127.102 79.2145C126.486 79.1873 125.888 79.4993 125.415 80.0921C124.924 80.7097 124.631 81.5505 124.591 82.4609C124.51 84.3089 125.499 85.8593 126.806 85.9153C128.109 85.9729 129.234 84.5161 129.316 82.6689C129.356 81.7593 129.138 80.8953 128.703 80.2369C128.33 79.6721 127.837 79.3217 127.297 79.2345Z",
    fill: "#514EFF"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M121.979 82.34L121.664 81.9288C122.272 81.4624 123.658 80.8592 124.558 81.912L124.164 82.248C123.36 81.3048 122.035 82.2984 121.979 82.34Z",
    fill: "#514EFF"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M105.461 82.7513L105.012 82.4937C105.133 82.2849 106.22 80.4449 107.383 80.3081C108.47 80.1833 114.615 80.9633 114.908 81.0041L114.836 81.5169C112.857 81.2409 108.282 80.7233 107.443 80.8225C106.675 80.9121 105.752 82.2457 105.461 82.7513Z",
    fill: "#514EFF"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M109.941 81.8296C109.941 81.8296 107.874 77.2224 105.835 77.884C103.798 78.5456 104.811 84.8464 106.823 86.0656C108.835 87.2848 110 85.444 110 85.444L109.941 81.8296Z",
    fill: "#DD6A57"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M106.171 79.6832C106.137 79.6736 106.121 79.7208 106.149 79.7392C107.55 80.644 108.081 82.204 108.363 83.7704C108.019 83.1224 107.462 82.6976 106.607 83.0912C106.562 83.112 106.588 83.1816 106.632 83.18C107.279 83.1656 107.707 83.3584 108.033 83.9368C108.263 84.3464 108.382 84.8312 108.517 85.2792C108.563 85.4288 108.821 85.4024 108.799 85.236C108.798 85.224 108.795 85.2112 108.794 85.1984C109.201 83.2704 108.213 80.2744 106.171 79.6832Z",
    fill: "#263238"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M178.844 70.7671C177.805 80.7047 168.901 87.9215 158.964 86.8823C154.948 86.4623 151.377 84.7575 148.613 82.2119L139.561 83.5407L144.089 75.7151C142.99 73.0415 142.528 70.0655 142.848 67.0023C143.887 57.0647 152.79 49.8479 162.728 50.8871C172.666 51.9263 179.883 60.8295 178.844 70.7671Z",
    fill: "white"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M178.844 70.7672C178.466 74.0704 177.259 77.3088 175.192 79.9392C174.718 80.6288 174.107 81.204 173.552 81.8272C172.923 82.3752 172.337 82.976 171.643 83.444C170.319 84.4632 168.832 85.2624 167.278 85.8744C165.731 86.5256 164.067 86.836 162.407 87.036C161.57 87.0808 160.731 87.1576 159.893 87.084C159.053 87.0648 158.216 86.9752 157.389 86.8232C154.078 86.2232 150.942 84.6736 148.437 82.4032L148.651 82.4688L139.608 83.8576L138.952 83.9584L139.284 83.38L143.787 75.5392L143.766 75.8488C141.572 70.684 142.067 64.5336 144.88 59.7216C146.283 57.312 148.239 55.236 150.547 53.6872C152.855 52.1344 155.531 51.1608 158.27 50.7896C161.012 50.4256 163.834 50.6752 166.452 51.5456C169.067 52.4264 171.465 53.9072 173.43 55.824C177.424 59.6216 179.432 65.3184 178.844 70.7672ZM178.844 70.7672C179.394 65.3144 177.347 59.652 173.351 55.9056C171.367 54.032 168.965 52.612 166.373 51.7888C163.777 50.976 160.999 50.7824 158.326 51.1856C155.654 51.596 153.066 52.5912 150.853 54.1376C148.646 55.688 146.784 57.7144 145.439 60.0424C144.068 62.3656 143.358 65.0272 143.143 67.6984C142.973 70.3792 143.411 73.092 144.416 75.5808L144.482 75.7424L144.395 75.8904L139.839 83.7008L139.515 83.2232L148.576 81.9544L148.701 81.9368L148.79 82.0208C151.185 84.2688 154.216 85.8384 157.454 86.484C158.263 86.6472 159.083 86.7496 159.908 86.7824C160.732 86.8696 161.558 86.808 162.384 86.7784C164.023 86.6096 165.675 86.3328 167.217 85.7144C168.766 85.1344 170.263 84.3736 171.582 83.3624C172.275 82.9016 172.863 82.308 173.493 81.7672C174.048 81.1512 174.662 80.5816 175.139 79.8984C177.215 77.2904 178.443 74.068 178.844 70.7672Z",
    fill: "#263238"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M158.73 79.204L151.002 71.3808L153.598 68.8152L158.112 73.3848L167.492 58.6808L170.569 60.6432L158.73 79.204Z",
    fill: "#514EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAddress);
export default __webpack_public_path__ + "static/media/noAddress.bc6ca647e0a6a3cb431a1e6fd84dda9d.svg";
export { ForwardRef as ReactComponent };